import { Content } from 'src/app/models/content.model';

export const TOOLS_CONTENT: Content = new Content({
   idContent: 'ed50542c6ca94fc909e8391bd59c69fc',
   order: 1,
   title: 'Herramientas de apoyo',
   content: `
   Proceso de formación, capacitación, adiestramiento con igualdad de oportunidades    
   <br><br>
   <div class="row">
      <div class="col-12 row">
         <div class="col-5 mx-auto">
            <app-button-url
               [url]="'http://www.gob.mx/cms/uploads/attachment/file/55293/10.1_Ejemplo_del_Proceso_de_formaci_n__capacitaci_n.pdf'"
               [title]="'Descargar'"
               [icon]="'description'">
            </app-button-url>
         </div>
      </div>
   </div>
   <br>
   Ejemplo de programa anual de capacitación en materia de igualdad laboral y no discriminación.
   <br><br>
   <div class="row">
      <div class="col-12 row">
         <div class="col-5 mx-auto">
            <app-button-url
               [url]="'http://www.gob.mx/cms/uploads/attachment/file/55294/10.2_Ejemplo_de_Programa_Anual_de_Capacitaci_n.pdf'"
               [title]="'Descargar'"
               [icon]="'description'">
            </app-button-url>
         </div>
      </div>
   </div>

   `,
   subContents: [
   ]
});